import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IGlobalState } from '../../model/IGlobalState';
import { startSetStock } from '../../actions/CurrentStock';
import api from '../../api/api';
import { CURRENT_TICKER_KEY } from './Header';

// a page opened from a link (e.g. a campaign of another client) calls this once its data has loaded:
// when the data belongs to another client than the one selected, select that client, as picking it in the header switcher would
const useSwitchToClient = (stockId: string | undefined) => {
    const currentStockId = useSelector((state: IGlobalState) => state.currentStock?.id);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!stockId || !currentStockId || stockId === currentStockId) return;
        let cancelled = false;
        // the current client is selected by ticker, so look it up among the user's clients
        api().getClientDashboardResult().then(r => {
            const client = r.stocks.find(s => s.id === stockId);
            if (cancelled || !client) return;
            localStorage.setItem(CURRENT_TICKER_KEY, client.combinedTicker);
            dispatch(startSetStock(client.combinedTicker));
        });
        return () => { cancelled = true; };
    }, [stockId, currentStockId, dispatch]);
};

export default useSwitchToClient;
